var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", { staticClass: "faq" }, [
    _c("div", { staticClass: "default-content" }, [
      _c("h2", { staticClass: "section-title" }, [
        _vm._v(
          _vm._s(
            _vm.locales &&
              _vm.locales.pages &&
              _vm.locales.pages.frequently_asked_questions
          )
        )
      ]),
      _vm._v(" "),
      _c(
        "ul",
        { staticClass: "faq__list" },
        _vm._l(_vm.itemsComputed, function(item, index) {
          return _c("li", { key: index, staticClass: "faq__list-item" }, [
            _c(
              "div",
              {
                staticClass: "faq__list-opener",
                on: {
                  click: function($event) {
                    return _vm.toggleItem(index)
                  }
                }
              },
              [
                _vm._v("\n          " + _vm._s(item.question) + "\n          "),
                !_vm.selected.includes(index)
                  ? _c("i", { staticClass: "icon-plus" })
                  : _c("i", { staticClass: "icon-minus" })
              ]
            ),
            _vm._v(" "),
            _vm.selected.includes(index)
              ? _c("div", { staticClass: "faq__list-content" }, [
                  _vm._v("\n          " + _vm._s(item.answer) + "\n        ")
                ])
              : _vm._e()
          ])
        }),
        0
      ),
      _vm._v(" "),
      _c(
        "a",
        {
          staticClass: "theme-btn theme-btn--tertiary",
          attrs: { href: "#" },
          on: {
            click: function($event) {
              $event.preventDefault()
              _vm.showMore = !_vm.showMore
            }
          }
        },
        [
          !_vm.showMore
            ? [
                _vm._v(
                  "\n        " +
                    _vm._s(
                      _vm.locales &&
                        _vm.locales.common &&
                        _vm.locales.common.show_more
                    ) +
                    "\n        "
                ),
                _c("i", { staticClass: "icon-thin-down" })
              ]
            : [
                _vm._v(
                  "\n        " +
                    _vm._s(
                      _vm.locales &&
                        _vm.locales.common &&
                        _vm.locales.common.show_less
                    ) +
                    "\n        "
                ),
                _c("i", { staticClass: "icon-thin-up" })
              ]
        ],
        2
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-c602b80a", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c602b80a","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/FAQ.vue
// module id = 585
// module chunks = 1